import { Box, Container, useTheme, useMediaQuery } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import mailDerpLogo from '../../logos/mailderp_logo_transparent.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Footer from '../components/Footer'

// Styled components
const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(4, 0, 2),
}))

const StyledLogo = styled('img')({
  maxWidth: '220px',
  height: 'auto',
})

const BackLink = styled(RouterLink)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  textDecoration: 'none',
  marginBottom: theme.spacing(3),
  '&:hover': {
    textDecoration: 'underline',
  }
}))

const FullWidthContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  padding: theme.spacing(0, 2),
  overflow: 'hidden',
}))

const IframeContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.mode === 'dark' ? '#1a1a1a' : '#fff',
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
}))

function Terms() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100vw'
    }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <LogoContainer>
          <StyledLogo src={mailDerpLogo} alt="MailDerp Logo" />
        </LogoContainer>

        <BackLink to="/">
          <ArrowBackIcon fontSize="small" sx={{ mr: 1 }} />
          Back to mailbox
        </BackLink>
      </Container>
      
      <FullWidthContainer>
        <IframeContainer>
          <iframe 
            src="/terms.html" 
            title="Terms of Service"
            style={{ 
              width: '100%',
              height: isMobile ? '80vh' : '70vh',
              border: 'none',
              flexGrow: 1,
            }}
          />
        </IframeContainer>
      </FullWidthContainer>

      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Footer />
        </Box>
      </Container>
    </Box>
  )
}

export default Terms